module.exports = __webpack_public_path__ + "static/media/TEA.63291a7d.png";